import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Slide from '@material-ui/core/Slide';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';

import MetricModule from './metricModule.js';
import { toggleSwitch } from '../../actions/index.js';
import { ColorAttributes, ToggleActions } from '../../constants/constants.js';
import { _ } from '../../functions/translator.js';
import InfoTooltip from '../infoTooltip/infoTooltip.js';
import CloseIcon from '@material-ui/icons/Close';

class MetricsContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            defaultLayoutConfig: {
                font_color: 'white',
                paper_bgcolor: '#212529',
                title: null,
            },
            metrics: {
                cards_groups_status_summary: {
                    description:  _('Estado de Registros'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                global_delay_percentage: {
                    description:  _('Cumplimiento de Registros'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                periodic_users_summary: {
                    description: _('Cumplimientos por Usuario'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                delayed_status_distribution: {
                    description: _('Atrasos por Estado'),
                },
                delayed_by_user: {
                    description: _('Atrasos por Usuario'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                delayed_by_stage: {
                    description: _('Atrasos por Etapa'),
                },
                delayed_by_level: {
                    description: _('Atrasos por Piso'),
                },
                delayed_by_protocol: {
                    description: _('Atrasos por Protocolo'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                    
                },
                fulfillment_per_user: {
                    description: _('% de Cumplimiento por Persona'),
                },
                global_observations_percentage: {
                    description: _('% de Observaciones'),
                    layout_config: {
                        height: 300,
                        margin: {
                            t: 50,
                            r: 40,
                            b: 10,
                            l: 30,
                        }
                    }
                },
                observations_per_stage: {
                    description: _('Observaciones por Etapa'),
                },
                most_observed_questions: {
                    description: _('Observaciones por Criterio'),
                },
                percentage_observations_per_protocolgroup: {
                    description: _('Observaciones Históricas por Protocolo'),
                },
                progress_analysis: {
                    description: _('Curva S'),
                },
                payment_status_progress: {
                    description: _('Estado de Pago'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                observations_per_level: {
                    description: _('Observaciones por Piso'),
                },
                observations_status_per_stage: {
                    description: _('Estado de Observaciones por Etapa'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                observations_status_per_stage: {
                    description: _('Estado de Observaciones por Etapa'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                answers_status_per_stage: {
                    description: _('Respuestas de Criterios por Etapa'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                },
                users_reliability: {
                    description: _('Confiabilidad de Usuarios'),
                    layout_config: {
                        margin: {
                            t: 0,
                            r: 0,
                            b: 0,
                            l: 0,
                        },
                        font_color: 'black',
                    }
                }
            },
            selectedMetrics: [],
        };
    }

    // componentDidUpdate(prevProps) {
    //     if (!this.props.loadingLevel && this.props.loadingLevel !== prevProps.loadingLevel) {
    //         if (this.state.selectedMetrics.length === 0) {
    //             this.setDefaultSelectedMetrics()
    //         }
    //     }
    // }
    componentDidUpdate(prevProps) {
        if (this.props.paint !== prevProps.paint && this.props.paint === ColorAttributes.PROGRESS) {
            this.setDelayedSelectedMetrics()
        }
        // if (!this.props.loadingLevel && this.props.loadingLevel !== prevProps.loadingLevel) {
        //     if (this.state.selectedMetrics.length === 0) {
        //         this.setDefaultSelectedMetrics()
        //     }
        // }
    }

    setDelayedSelectedMetrics = () => {
        const progressAnalysisMetricKey = "progress_analysis";
        const paymentStatusProgressMetricKey = "payment_status_progress";
        const progressAnalysisMetric = React.cloneElement(
            <MetricModule key={progressAnalysisMetricKey}/>,
            { 
                metricKey: progressAnalysisMetricKey,
                description: this.state.metrics[progressAnalysisMetricKey].description,
                layoutConfig: {
                    ...this.state.defaultLayoutConfig,
                    ...this.state.metrics[progressAnalysisMetricKey].layout_config
                },
                closeCallback: this.removeMetric,
            }
        );
        const paymentStatusProgressMetric = React.cloneElement(
            <MetricModule key={paymentStatusProgressMetricKey}/>,
            { 
                metricKey: paymentStatusProgressMetricKey,
                description: this.state.metrics[paymentStatusProgressMetricKey].description,
                layoutConfig: {
                    ...this.state.defaultLayoutConfig,
                    ...this.state.metrics[paymentStatusProgressMetricKey].layout_config
                },
                closeCallback: this.removeMetric,
            }
        );
        this.setState({
            selectedMetrics: [progressAnalysisMetric, paymentStatusProgressMetric]
        });
    }


    handleClose = () => {
        this.props.toggleSwitch(ToggleActions.METRICS, false);
        // this.setState({
        //     selectedMetrics: []
        // });
    }

    setDefaultSelectedMetrics = () => {
        const globalDelayMetricKey = "global_delay_percentage";
        const globalObservationsMetricKey = "global_observations_percentage";
        const globalDelayMetric = React.cloneElement(
            <MetricModule key={globalDelayMetricKey}/>,
            { 
                metricKey: globalDelayMetricKey,
                description: this.state.metrics[globalDelayMetricKey].description,
                layoutConfig: {
                    ...this.state.defaultLayoutConfig,
                    ...this.state.metrics[globalDelayMetricKey].layout_config
                },
                closeCallback: this.removeMetric,
            }
        );
        const globalObservationsMetric = React.cloneElement(
            <MetricModule key={globalObservationsMetricKey}/>,
            { 
                metricKey: globalObservationsMetricKey,
                description: this.state.metrics[globalObservationsMetricKey].description,
                layoutConfig: {
                    ...this.state.defaultLayoutConfig,
                    ...this.state.metrics[globalObservationsMetricKey].layout_config
                },
                closeCallback: this.removeMetric,
            }
        );
        this.setState({
            selectedMetrics: this.state.selectedMetrics.concat([globalDelayMetric, globalObservationsMetric])
        });
    }

    handleMetricsChange = (event) => {
        const metricKeys = event.target.value;
        const newMetrics = metricKeys.map(metricKey =>{
            return React.cloneElement(
                <MetricModule key={metricKey}/>,
                { 
                    metricKey: metricKey,
                    description: this.state.metrics[metricKey].description,
                    layoutConfig: {
                        ...this.state.defaultLayoutConfig,
                        ...this.state.metrics[metricKey].layout_config
                    },
                    closeCallback: this.removeMetric,
                }
            )}
        )
        this.setState({
            selectedMetrics: newMetrics
        });
    }

    handleClose = () => {
        this.props.toggleSwitch(ToggleActions.METRICS, false);
    }


    removeMetric = (metricKey) => {
        const filteredMetrics = this.state.selectedMetrics.filter(metric => metric.props.metricKey !== metricKey);
        this.setState({ selectedMetrics: filteredMetrics });
    }

    render() {
        const metricsOptions = [];
        // metricsOptions.push(
        //     <MenuItem key={'-'} value={'-'}>
        //         -
        //     </MenuItem>
        // );
        const metricsKeySelected = this.state.selectedMetrics.map(metric => metric.props.metricKey);
        for (const [key, metricData] of Object.entries(this.state.metrics)) {
            //if (metricsKeySelected.includes(key)) continue;
            metricsOptions.push(
                <MenuItem key={key} value={key}>
                    <Checkbox color="primary" checked={metricsKeySelected.includes(key)}/>
                    {metricData.description}
                </MenuItem>
            );
        }
        const metricsDropdownClass = this.props.itemsSwitch ? 'metrics-dropdown metrics-down' : 'metrics-dropdown';
        //let selectedMetricsClass = this.props.itemsSwitch ? 'selected-metrics-container selected-metrics-down' : 'selected-metrics-container';
        let selectedMetricsClass = this.props.itemsSwitch ? 'selected-metrics-container metrics-down' : 'selected-metrics-container';
        let metricsContainer = 'metrics-container'
        if (this.state.selectedMetrics.length === 0) {
            metricsContainer = 'no-height'
            selectedMetricsClass = 'no-height'
        }
        return(
            <Slide in={this.props.metrics && !this.props.popUpMenu.show} direction='left'>
                <div className={metricsContainer}>
                    <div className={metricsDropdownClass}>
                        <p className='text filter-title'>
                            <InfoTooltip class={'float-left'} placement={'left'} message={'metrics message'}/>
                            <p className='text mt-0'>{ _('Métricas disponibles') }
                                <CloseIcon className='float-right cursor-pointer' onClick={this.handleClose}/>
                            </p>
                        </p>
                        <Select
                            value={this.state.selectedMetrics.map(metric => metric.props.metricKey)}
                            renderValue={(selected) => (
                                <div>
                                    {selected.map(selected => this.state.metrics[selected].description).join(', ')}
                                </div>
                            )}
                            onChange={this.handleMetricsChange}
                            multiple
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                      maxHeight: 300,
                                      top: '0px',
                                      position: 'fixed',
                                    },
                                },
                                getContentAnchorEl: null,
                            }}>
                            {metricsOptions}
                        </Select>
                    </div>
                    <div className={selectedMetricsClass}>
                        {this.state.selectedMetrics}
                    </div>
                </div>
            </Slide>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        menu        : state.switches.menu,
        metrics     : state.switches.metrics,
        itemsSwitch : state.switches.items,
        timeline    : state.switches.timeline,
        projectData : state.projectData,
        loadingLevel   : state.switches.loadingLevel,
        popUpMenu   : state.popUpMenu,
        paint       : state.paint,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(MetricsContainer);